<template>
  <v-list-item>
    <v-list-item-content
      :style="{flexWrap: 'unset'}"
    >
      <RowElement
        v-for="(elementData, elementIndex) in rowData"
        :key="elementIndex"
        :element-data="elementData"
        :element-index="elementIndex"
        :row-index="parseInt(rowIndex)"
      />
    </v-list-item-content>
    <v-list-item-action
      :style="{justifyContent: 'start'}"
    >
      <v-btn
        :disabled="!computedIsRowMovableUp"
        icon
        @click="moveRow({fromIndex: rowIndex, toIndex: rowIndex - 1 })"
      >
        <v-icon
          color="blue"
        >
          mdi-menu-up
        </v-icon>
      </v-btn>
      <v-btn
        :disabled="!computedIsRowMovableDown"
        icon
        @click="moveRow({fromIndex: rowIndex, toIndex: rowIndex + 1 })"
      >
        <v-icon
          color="blue"
        >
          mdi-menu-down
        </v-icon>
      </v-btn>
      <v-btn
        @click="deleteRowWithConfirmation(rowIndex)"
      >
        <v-icon
          left
          color="red"
        >
          mdi-delete
        </v-icon>
        DELETE ROW {{rowIndex + 1}}
      </v-btn>
    </v-list-item-action>

  </v-list-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RowElement from './RowElement.vue';

export default {
  name: 'DynamicRow',
  components: {
    RowElement,
  },

  props: {
    rowData: {
      type: Array,
    },

    rowIndex: {
      type: Number,
    },
  },

  data: () => ({
  }),

  methods: {
    ...mapActions({
      deleteRow: 'microsite/deleteRow',
      moveRow: 'microsite/moveRow',
      addRowElement: 'microsite/addEmptyElementToTheRowEnd',
    }),

    deleteRowWithConfirmation(position) {
      this.$confirm(`Are you sure you want to delete row ${position + 1}?`).then((res) => {
        if (!res) return;

        this.deleteRow(position);
      });
    },
  },

  computed: {
    ...mapGetters({
      isRowFull: 'microsite/isRowFull',
      isRowMovableUp: 'microsite/isRowMovableUp',
      isRowMovableDown: 'microsite/isRowMovableDown',
    }),

    computedIsRowFull() {
      return this.isRowFull(this.rowIndex);
    },
    computedIsRowMovableUp() {
      return this.isRowMovableUp(this.rowIndex);
    },
    computedIsRowMovableDown() {
      return this.isRowMovableDown(this.rowIndex);
    },
  },
};
</script>
<style scoped>

</style>
